import selectedAtteributes from "@/constants/selectedAttrubites";
import axiosRequest from "@/utils/axios-config";

const getProductBySku = async (handshake, sku, getFullResponnse = true) => {
  const config = {
    method: "get",
    url: `/search/product/${sku}`,
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
  };
  if (!getFullResponnse) {
    config.url += `?${selectedAtteributes}`;
  }

  try {
    const req = await axiosRequest(config);
    console.log("getProductBySku ==================>>", {req, config});
    return req;
  } catch (error) {
    console.log("getProductBySku ==================>>", error);
    return error;
  }
};

const getAmastyMostviewedRelatedProductsBySku = async (
  handshake,
  sku,
  limit = 5,
  collection_type = ""
) => {
  const config = {
    method: "get",
    url: `/customer/amasty_mostviewed_related_products?sku=${sku}&limit=${limit}&${collection_type}`,
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
  };

  try {
    const req = await axiosRequest(config);
    console.log("getProductBySku ==================>>", req);
    return req;
  } catch (error) {
    console.log("getProductBySku ==================>>", error);
    return error;
  }
};

const getProductsBySkus = async (
  handshake,
  skuBulk,
  getFullResponnse = true
) => {
  const transformSKus = skuBulk
    ? skuBulk.map((sku) => "sku=" + sku).join("&")
    : "";

  const config = {
    method: "get",
    url: "/search/product?" + transformSKus,
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
    params:{
      pageSize:60,
      pageNo:0
    }
  };
  if (!getFullResponnse) {
    config.url += `&${selectedAtteributes}`;
  }
  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};

const submitQuestion = async (question, product_sku, handshake) => {
  const data = JSON.stringify({ question, product_sku, store_id: 1 });
  const config = {
    method: "post",
    url: "/faqs/addFaq",
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
    data,
  };

  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};

const updatedSubmitQuestion = async (question, product_sku, customer_id, handshake) => {
  const data = JSON.stringify({ question, product_sku, store_id: 1, customer_id });
  const config = {
    method: "post",
    url: "/faqs/addFaqQuestion",
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
    data,
  };

  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};

const submitAnswer = async (question_id, product_sku, answer, customer_id, handshake) => {
  const data = JSON.stringify({ question_id, product_sku, answer, customer_id, store_id: 1 });
  const config = {
    method: "post",
    url: "/faqs/addFaqAnswer",
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
    data,
  };

  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getProductFaqs = async (sku, handshake) => {

  const config = {
    method: "get",
    url: `/faqs/getProductFaqs/${sku}/1`,
    headers: {
      Authorization: `Bearer ${handshake}`,
    }
  };

  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};

const notifyMe = async (handshake, entityId, userId) => {
  let config = {
    method: "get",
    url: `/mstore/notify-product/${userId}/${entityId}`,
    headers: {
      Authorization: "Bearer " + handshake,
    },
  };

  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};

export {
  getProductBySku,
  getAmastyMostviewedRelatedProductsBySku,
  getProductsBySkus,
  submitQuestion,
  updatedSubmitQuestion,
  submitAnswer,
  getProductFaqs,
  notifyMe,
};
